var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.084 28.667v-15h-4.167v15h4.167zM19.084 8.667a2.083 2.083 0 11-4.167 0 2.083 2.083 0 014.167 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 .333a16.667 16.667 0 100 33.334A16.667 16.667 0 0017 .333zM17 2a15 15 0 110 30 15 15 0 010-30z"
  })));
}
export default SvgInfoOutline;